import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { VendedorService } from '../../../core/services/vendedores/vendedor.service';
import { Vendedor } from '../../../core/models/vendedores/vendedor';

@Component({
    selector: 'app-vendedor-typeahead',
    templateUrl: './vendedor-typeahead.component.html',
    standalone: false
})
export class VendedorTypeaheadComponent implements OnInit {
  @Input() vendedorSelecionado: string = '';
  @Output() vendedorChange = new EventEmitter<string>();

  vendedores: Vendedor[] = [];
  inputValue: string = '';

  constructor(private vendedorService: VendedorService) {}

  ngOnInit() {
    this.inputValue = this.vendedorSelecionado || '';
    this.vendedorService.getByUsuario().subscribe(
      v => { this.vendedores = v || []; },
      () => { this.vendedores = []; }
    );
  }

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => {
        if (term.length < 1) return [];
        const lower = term.toLowerCase();
        return this.vendedores
          .filter(v => v.fullname && v.fullname.toLowerCase().includes(lower))
          .slice(0, 10);
      })
    );

  formatter = (v: Vendedor) => v.fullname;

  onSelect(event: any) {
    event.preventDefault();
    const v: Vendedor = event.item;
    this.inputValue = v.fullname;
    this.vendedorChange.emit(v.fullname);
  }

  onBlur() {
    this.vendedorChange.emit(this.inputValue);
  }

  onClear() {
    this.inputValue = '';
    this.vendedorChange.emit('');
  }
}
